import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetInputsQuery,
  usePublicGetInputsQuery,
  useGetInputEntriesQuery,
  usePublicGetInputEntriesQuery,
  useGetInputEntriesDefaultsQuery,
  usePublicGetInputEntriesDefaultsQuery,
  useUpdateInputsMutation,
  useCreateInputEntryMutation,
  useUpdateInputEntryMutation,
  useDeleteInputEntryMutation
} from '../features/modules/inputsApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting inputs data based on the current route.
 */
export const useContextAwareGetInputs = createContextAwareHook(
  useGetInputsQuery,
  usePublicGetInputsQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting input entries based on the current route.
 */
export const useContextAwareGetInputEntries = createContextAwareHook(
  useGetInputEntriesQuery,
  usePublicGetInputEntriesQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting input entries defaults based on the current route.
 */
export const useContextAwareGetInputEntriesDefaults = createContextAwareHook(
  useGetInputEntriesDefaultsQuery,
  usePublicGetInputEntriesDefaultsQuery
);

// Export mutation hooks directly
export {
  useUpdateInputsMutation,
  useCreateInputEntryMutation,
  useUpdateInputEntryMutation,
  useDeleteInputEntryMutation
}; 